
/* injects from baggage-loader */

import React from "react";
import { connect } from "react-redux";
import { ClosePopup } from "../../../actions/ui";
import { t } from "../../../helpers/translator";
import CountDownComponent from "../countDownClock";

const TerminalLockReminderPopup = ({ data, dispatch }) => (
	<div className="popup-m" onClick={() => dispatch(ClosePopup())}>
		<div className="mini-box-popup">
			<div className="align-wrapper">
				<div className="ver-center-view-b">
					<div className="title-popup-page-m">
						<button
							className="popup-closed-b"
							onClick={() => dispatch(ClosePopup())}
						/>
					</div>
					<div className="popup-content-view-m timer-visible">
						<div className="mini-box-popup">
							<div className="ticket-results-view-p inactive-popup">
								<CountDownComponent second={data} />
								<p>{t(`Terminal will be locked soon.`)}</p>
							</div>
						</div>
						<div class="separator-box-buttons-m">
							<button class="button-view-normal-m incative">{t("Ok")}</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default connect()(TerminalLockReminderPopup);
